export default "__VITE_ASSET__r28qE36b__"